export default __webpack_public_path__ + "static/ansible-6290c85c6c2d35c51b44f9611122548e.png";